mutation UpdateCountryAccess($id: ID!, $input: UpdateCountryAccessInput!) {
  updateCountryAccess(id: $id, input: $input) {
    id
    title
    type
    countries
    isDefault
  }
}
